<template>
  <div
    id="upload-id"
    class="md:tw-w-96 tw-w-11/12 tw-flex tw-flex-col tw-items-center tw-pb-8"
  >
    <OnboardingHeader headerText="Take selfie" />
    <OnboardingSubHeader
      subHeaderText="We compare your selfie with your ID Photo."
    />
    <UploadSelfieForm @upload="upload" />
  </div>
</template>

<script>
import OnboardingHeader from "@/components/onboarding/OnboardingHeader.vue";
import OnboardingSubHeader from "@/components/onboarding/OnboardingSubHeader.vue";
import UploadSelfieForm from "@/components/onboarding/forms/UploadSelfieForm.vue";

export default {
  name: "UploadSelfie",

  components: { UploadSelfieForm, OnboardingHeader, OnboardingSubHeader },

  methods: {
    upload(payload) {
      //   console.log(payload);
    },
  },
};
</script>

<style lang="scss" scoped></style>
